import React from "react";
import { useState } from "react";
import { HiMinusSm, HiPlus } from "react-icons/hi";

const BasketChangeQuantity = ({ loading, value, setValue }) => {
  return (
    <div
      className="rounded28 border p-0 row mx-auto text-center mt-3"
      style={{ width: "70%", height: "50px", maxWidth: "260px" }}
    >
      <button
        className="btn col p-0 align-self-center color-second border-0"
        disabled={loading}
        onClick={() => setValue((preVal) => preVal + 1)}
      >
        <HiPlus size="20" />
      </button>

      <div className="col-auto px-0 align-self-center">
        {loading ? (
          <span className="spinner-border spinner-border-sm color-second align-middle" />
        ) : (
          <span>{value}</span>
        )}
      </div>
      <button
        className="btn col p-0 align-self-center color-second border-0"
        disabled={loading || value < 2}
        onClick={() => setValue((preVal) => preVal - 1)}
      >
        <HiMinusSm size="24" />
      </button>
    </div>
  );
};

export default BasketChangeQuantity;
